// UK Locker Hire — calendar widget for the quote form
(function(){
  var calendarEl = document.getElementById('hireCalendar');
  if(!calendarEl) return;

  var monthLabel = document.getElementById('calMonthLabel');
  var grid = document.getElementById('calGrid');
  var prevBtn = document.getElementById('calPrev');
  var nextBtn = document.getElementById('calNext');
  var deliveryOut = document.getElementById('calDeliveryOut');
  var collectionOut = document.getElementById('calCollectionOut');
  var deliveryInput = document.getElementById('deliveryDate');
  var collectionInput = document.getElementById('collectionDate');

  var MONTH_NAMES = ['January','February','March','April','May','June','July','August','September','October','November','December'];

  var today = stripTime(new Date());
  var view = { year: today.getFullYear(), month: today.getMonth() };
  var delivery = null;
  var collection = null;

  function stripTime(d){ return new Date(d.getFullYear(), d.getMonth(), d.getDate()); }
  function sameDate(a, b){ return a && b && a.getTime() === b.getTime(); }
  function fmtISO(d){
    if(!d) return '';
    var m = d.getMonth() + 1, day = d.getDate();
    return d.getFullYear() + '-' + (m < 10 ? '0' + m : m) + '-' + (day < 10 ? '0' + day : day);
  }
  function fmtDisplay(d){
    if(!d) return '';
    return d.getDate() + ' ' + MONTH_NAMES[d.getMonth()].slice(0,3) + ' ' + d.getFullYear();
  }

  function render(){
    monthLabel.textContent = MONTH_NAMES[view.month] + ' ' + view.year;
    grid.innerHTML = '';

    var firstOfMonth = new Date(view.year, view.month, 1);
    var leadingBlanks = (firstOfMonth.getDay() + 6) % 7; // Monday-first
    var daysInMonth = new Date(view.year, view.month + 1, 0).getDate();

    for(var i = 0; i < leadingBlanks; i++){
      var blank = document.createElement('span');
      blank.className = 'cal-day empty';
      grid.appendChild(blank);
    }

    for(var day = 1; day <= daysInMonth; day++){
      var d = new Date(view.year, view.month, day);
      var cell = document.createElement('span');
      cell.className = 'cal-day';
      cell.textContent = day;

            var minSelectable = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 2);
      var isTooSoon = d.getTime() < minSelectable.getTime();

      if(isTooSoon){
        cell.classList.add('disabled');
      } else {
        cell.addEventListener('click', (function(dateVal){
          return function(){ handleDayClick(dateVal); };
        })(d));
      }

      if(sameDate(d, today)) cell.classList.add('today');
      if(sameDate(d, delivery)) cell.classList.add('is-start');
      if(sameDate(d, collection)) cell.classList.add('is-end');
      if(delivery && collection && d.getTime() > delivery.getTime() && d.getTime() < collection.getTime()){
        cell.classList.add('in-range');
      }

      grid.appendChild(cell);
    }
  }

  function handleDayClick(d){
    if(!delivery || collection){
      delivery = d;
      collection = null;
    } else if(sameDate(d, delivery)){
      delivery = null;
      collection = null;
    } else if(d.getTime() > delivery.getTime()){
      collection = d;
    } else {
      delivery = d;
      collection = null;
    }
    updateSummary();
    render();
  }

  function updateSummary(){
    deliveryOut.textContent = delivery ? fmtDisplay(delivery) : 'Select a Date';
    collectionOut.textContent = collection ? fmtDisplay(collection) : (delivery ? 'Select a Date' : '—');
    deliveryInput.value = fmtISO(delivery);
    collectionInput.value = fmtISO(collection);
  }

  prevBtn.addEventListener('click', function(){
    view.month -= 1;
    if(view.month < 0){ view.month = 11; view.year -= 1; }
    render();
  });
  nextBtn.addEventListener('click', function(){
    view.month += 1;
    if(view.month > 11){ view.month = 0; view.year += 1; }
    render();
  });

  render();
  updateSummary();
})();